import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Desktop, Mobile } from '../../../App';
import { Flexed, SectionSeparator } from '../../../styles/GlobalComponents';
import { FlexCenter, FlexEnd } from '../../../styles/stylesStyled';
import { LevelZero } from '../common/desktop';
import { getLevels } from '../myTeamBackOffice.actions';
import {
  FlexJustifyCenter,
  GenerationsDate,
  GenerationsDesktop,
  GenerationsInfo
} from '../MyTeamBackofficeStyled';
import UserComponent from '../UserComponent';
import Generation from './Generation';

const Generations = ({ tab }) => {
  const { t } = useTranslation('myTeam');
  const { user } = useSelector((state) => state.auth.userInfo);
  const { userAsTeamMember, userAsTeamMemberInfo, levels } = useSelector(
    (state) => state.myTeamBackoffice
  );

  const dispatch = useDispatch();
  useEffect(() => {
    if (!levels) dispatch(getLevels());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <FlexJustifyCenter
        style={{ flexDirection: 'column', alignItems: 'center' }}>
        <Desktop style={{ width: '100%' }}>
          <div
            style={{
              width: '100%',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center'
            }}>
            <LevelZero
              teamMember={userAsTeamMember}
              teamMemberInfo={userAsTeamMemberInfo}
              tab={tab}
            />
            {/* <SectionSeparator
              margin={'32px 0 40px 0'}
              style={{ maxWidth: '680px' }}
            /> */}
            <Flexed mt='32'></Flexed>
            {levels?.map((level, i) => {
              return (
                <GenerationsDesktop key={i}>
                  <div>
                    <GenerationsDate isLocked={level.isLocked}>
                      {`${t('generations_page.generation')} ${level?.level}`}{' '}
                      <br />
                      <h2>
                        <span> {t('generations_page.total')}: </span>
                        {level.levelUsersCount !== null
                          ? level.levelUsersCount
                          : 0}
                      </h2>
                    </GenerationsDate>
                    <GenerationsInfo>
                      <div>
                        <h2>{t('generations_page.today')}</h2>
                        <h3>{`+${level.todayChange}`}</h3>
                      </div>
                    </GenerationsInfo>
                    <GenerationsInfo>
                      <div>
                        <h2>{t('generations_page.this_week')}</h2>
                        <h3>{`+${level.weekChange}`}</h3>
                      </div>
                    </GenerationsInfo>
                    <GenerationsInfo>
                      <div>
                        <h2>{t('generations_page.this_month')}</h2>
                        <h3>{`+${level.monthChange}`}</h3>
                      </div>
                    </GenerationsInfo>
                  </div>
                </GenerationsDesktop>
              );
            })}
          </div>
        </Desktop>

        <Mobile style={{ width: '100%' }}>
          <FlexCenter style={{ flexDirection: 'column' }}>
            <UserComponent user={user} />
          </FlexCenter>

          {/* <SectionSeparator margin={'40px 0'} style={{ maxWidth: '680px' }} /> */}
          {levels?.map((level, i) => {
            return <Generation level={level} key={i} />;
          })}
        </Mobile>
      </FlexJustifyCenter>
    </>
  );
};

export default Generations;
